module.exports = __webpack_public_path__ + "static/media/air-conditioner.4a27ae45.svg";